import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FeathersService } from '../../feathers.service'
import { map, shareReplay } from 'rxjs/operators'
import { Workgroup } from '../../../models/workgroup'
import { SearchUtils } from '../../../shared/utils/searchUtils'

@Injectable({
  providedIn: 'root',
})
export class WorkgroupService {
  private feathers = inject(FeathersService)

  static ALL_WORKGROUPS = 999

  stream$: Observable<Workgroup[]>

  public getAllWithCaching(): Observable<Workgroup[]> {
    if (!this.stream$) this.init()
    return this.stream$
  }

  private init() {
    this.stream$ = this.feathers.find(Workgroup, {}).pipe(
      map((wgs: Workgroup[]) =>
        wgs.sort((a, b) => {
          if (SearchUtils.normalizeForSearch(a.name) < SearchUtils.normalizeForSearch(b.name)) return -1
          if (SearchUtils.normalizeForSearch(a.name) > SearchUtils.normalizeForSearch(b.name)) return 1
          return 0
        }),
      ),
      shareReplay({ bufferSize: 1, refCount: true }),
    )
  }

  public getAll(): Observable<Workgroup[]> {
    return this.feathers.find(Workgroup, {})
  }

  getById(workgroupId: number): Observable<Workgroup> {
    return this.getAllWithCaching().pipe(map((wgs) => wgs.filter((wg) => wg.id === workgroupId)[0]))
  }
}
